import { render, staticRenderFns } from "./ReviewerHistory.vue?vue&type=template&id=03517c85&scoped=true&"
import script from "./ReviewerHistory.vue?vue&type=script&lang=js&"
export * from "./ReviewerHistory.vue?vue&type=script&lang=js&"
import style0 from "./ReviewerHistory.vue?vue&type=style&index=0&id=03517c85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03517c85",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03517c85')) {
      api.createRecord('03517c85', component.options)
    } else {
      api.reload('03517c85', component.options)
    }
    module.hot.accept("./ReviewerHistory.vue?vue&type=template&id=03517c85&scoped=true&", function () {
      api.rerender('03517c85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/ReviewerHistory.vue"
export default component.exports